import { ILoadScriptOptions } from 'esri-loader';

import { IEnvironment } from './environment';
import { IAuthenticationServiceConstructor } from './services/interfaces/IAuthenticationService';
import { ILoggingServiceConstructor } from './services/interfaces/ILoggingService';
import { IUserSettingsServiceConstructor } from './services/interfaces/IUserSettingsService';

declare global {
    // tslint:disable-next-line:interface-name
    interface Window {
        esriConfig?: ILoadScriptOptions;

        overrideStylesheet?: string;
        environment?: string;
        environmentConfig?: IEnvironment;

        AuthenticationService?: IAuthenticationServiceConstructor;
        LoggingService?: ILoggingServiceConstructor;
        UserSettingsService?: IUserSettingsServiceConstructor;

        jQuery?: IJquery;
        $?: IJquery;

        google?: { maps?: any };
        mc2ga?: UniversalAnalytics.ga;
        GoogleAnalyticsObject: string;
        googleMapsApiCallback: () => void;
    }
    // tslint:disable-next-line:interface-name
    interface String {
        replaceAll(searchValue: string | RegExp, replaceString: string | ((this, searchValue, index) => string)): string;
    }
}

interface IJquery {
    [key: string]: any;
}

window.esriConfig = window.esriConfig || { url: 'https://js.arcgis.com/4.23/', version: '4.23', css: true };
